<template>
  <div class="sports_rank">
    <van-sticky>
      <div class="tabs">
        <div class="tab" :class="[active==1?'active':'']" @click="check(1)">线路1</div>
        <div class="tab" :class="[active==2?'active':'']" @click="check(2)">线路2</div>
      </div>
    </van-sticky>
    <div class="myinfo">
      <div class="base">
        <div>
          <div>
            <div>{{myinfo.nickname}}</div>
          </div>
          <div class="myrank">
            <template v-if="+myinfo.rank > 0">第 {{ myinfo.rank }} 名</template>
            <template v-else>暂无排名</template>
          </div>
        </div>
        <div>
          <div>{{myinfo.time|Timetype}}</div>
          <div>减时：{{myinfo.notice}}</div>
        </div>
      </div>
    </div>
    

    <!-- <List
      style="color:#FFF;"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="getRankList"
    > -->
      <div class="rank-list">
        <div class="item" v-for="(item,index) in rankList" :key="index" v-if="rankList.length">
          <div class="collapse-title">
            <div class="rank_icon">
              <template v-if="item.rank <= 3">
                <img src="@/assets/img/rank/first.png" :alt="item.rank" v-if="item.rank == 1" />
                <img src="@/assets/img/rank/second.png" :alt="item.rank" v-if="item.rank == 2" />
                <img src="@/assets/img/rank/third.png" :alt="item.rank" v-if="item.rank == 3" />
              </template>
              <span v-else>{{ item.rank }}</span>
            </div>
            <div>
              <div>{{item.name}}</div>                  
            </div>
            
          </div>
          <div class="collapse-value">
              <div>{{item.time|Timetype}}</div>
              <div>减时：{{item.notice}}</div>
          </div>
        </div>
        <Empty
          style="background: #fff;min-height: 6rem"
          :style="`border-radius: ${borderRadius}`"
          v-else
          description="暂无数据"
        />
      </div>
    <!-- </List> -->
  </div>
</template>

<style lang="less" scoped>
@import "./index.less";

.filter {
  width: 6.9rem;
  margin: 0 auto;
  display: flex;
  align-items: center;

  .item {
    font-size: 0.3rem;
    padding: 0.12rem 0;
    width: 2rem;
    display: flex;
    justify-content: center;
    border-radius: 0.2rem 0.2rem 0 0;

    &.active {
      background: #fff;
      color: #333;
    }
  }
}
</style>

<script>
import { Empty, Panel, Cell, CellGroup, Image, List, Row, Col, Popup,Collapse, CollapseItem,Sticky } from "vant";

export default {
  computed: {
    buttonColor() {
      let detail = this.detail;
      if (!detail) return "#ccc";
      return `${detail.tabstyle[0]["color"]}`;
    },
    borderRadius() {
      if (this.filter) {
        let i = this.filter.findIndex((row) => {
          return row.active == 1;
        });
        if (i == 0) {
          return "0 .2rem .2rem .2rem";
        } else {
          return ".2rem";
        }
      }
    },
  },
  components: {
    Empty,
    Panel,
    Cell,
    CellGroup,
    List,
    VanImage: Image,
    VanSticky: Sticky,
    Row,
    Col,
    Popup,
    vanCollapse:Collapse, vanCollapseItem:CollapseItem
  },
  data() {
    return {
      activeNames: [],
      rankList: [],
      loading: false,
      finished: false,
      detail: "",
      page: 1,
      systime: "",
      myinfo: "",
      register_type: "",
      filter: [],
      type: "",
      physical_item_id: 0,
      showVideo: false,
      videoUrl: '',
      animation: 0,
      active: 1,
      activity_id: 1238,
      typeids: '1005855,1005917'
    };
  },
  methods: {
    getRankList: function () {
      //如果为空or 0 按照 item_id  rank
      this.$api.activity.qrcoderank({activity_id: this.activity_id,typeids:this.typeids}).then(res=>{
          if(res.status === 200) {
            this.loading = false;          
            this.myinfo = res.data.myinfo
            this.rankList = res.data.list
            let t = null

            this.rankList.forEach((item, index) => {
                if(t == null){
                    t =  item;
                    t.rank = index+1;
                }else{
                    var n = item;
                    if(n.time*1 == t.time*1){
                        n.rank = t.rank;
                    }else{
                          n.rank = index+1;
                    }
                    t = n;
                }
            })
            this.finished = true;
          }
      })
    },
    init: function () {
    },
    check(type) {
      switch(type*1) {
        case 1:
          this.active = 1;
          this.activity_id = 1238
          this.typeids = '1005855,1005917'
          break
        case 2:
          this.active = 2;
          this.activity_id = 1239
          this.typeids = '1005857,1005918'
          break
      }
      this.getRankList();
    }
  },
  mounted() {
    this.init();
    this.activity_id = this.$route.params.acid
    this.getRankList();
  },
};
</script>
